<template>
  <div> 
    <div class='glitchHolder'>
      <div v-if="glitches" id="glitchOverlay" :style="{top:glitchTop+'px'}">
        <div v-for="g in glitches" class='glitchOver' :style="{marginBottom:g.pad+'px',width:g.width+'%'}">
        <div v-for="gc in g.child" class='glitchChild' :style="{backgroundColor:g.colour,height:g.height+'px',marginLeft:gc+'px',width:g.width+'px'}"></div>
        </div>
      </div>
    </div>
    <v-container ma-0 pt-0  >
      <v-layout >
        <v-flex xs12 class="text-xs-center">
          <v-progress-circular indeterminate :size="50" 
            color="grey" 
            :width="7" 
            v-if="loading"></v-progress-circular>
        </v-flex>
      </v-layout>    
      <v-layout>
        <v-flex xs12 offset-xs0 sm10 offset-sm2 pa-2 >
       
          <h2>Slowbart</h2>
           <img src="../assets/images/Slowbart.jpg" width="100%"></img>
          <br>
          <h2>Call out for film and video content for a new program on The Loop</h2>
          
         
          <p>From ambient landscapes and soundscapes to leisurely depictions of local happenings, Slowbart is about stories told at a relaxed pace. It’s about gradually unfolding moments and experiences, designed to be enjoyed by audiences as they wait, or pass by, or settle in for the long-haul.</p>
          
          <p>Emerging curators Victoria Bremner and Heath Willis from the School of Media at the University of Tasmania are seeking film and video that encapsulates these ideas, whether in narrative or non-narrative form.</p>
          
          <p>Filmmakers, artists and content makers of all kinds are asked to scour their hard drives, delve into the depths of their filing cabinets and check under their beds to contribute imagery for this program...</p>
          <p>Do you have some stunning footage that’s never quite fitted in anywhere? A long cut of an existing work? A strangely meditative tale?  </p>
          
          <h2>Submit before Wednesday 17 April 2019.</h2>
          <p>Slowbart will screen on The Loop, the City of Hobart’s digital art platform located in the public courtyard of 157 Elizabeth Street, from May to July 2019. The program will be launched with a special media event to celebrate the selected work. </p><p>
Please note that The Loop does not accept commercial or advertising content.</p>
<p>
          To submit content for consideration go to:  <v-btn :to="'/participate'"><span style="text-transform: lowercase;">theloophobart.com.au/participate</span></v-btn>
        <p>For all enquiries email: <v-btn  href="mailto:publicart@hobartcity.com.au"><span style="text-transform: lowercase;">publicart@hobartcity.com.au</span></v-btn>
          
         </p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
 export default {
   
   data () {
     return {
       glitches:null,
       glitchCount:20,
       glitchTop:0
     }
   },
   mounted(){
     this.glitches=[]
     let childA=[]  
      for(var i=0;i<8;i++){
        childA=[]
        for(var p=0;p<2;p++){
          childA.push(Math.floor(Math.random()*100));   
        }
        this.glitches.push({colour:'#00000044',height:30,pad:3,width:Math.random()*50+50,child:childA})
      }
      setTimeout(this.glitch,100);
   },
   computed: {
     loading () {
       return this.$store.getters.loading
     },
     userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    
    },
   methods: {
     glitch(){

        this.glitchCount++
        if(this.glitchCount>50){
            this.glitchCount=Math.random()*20-10
            this.glitchTop=Math.random()*400+100;
        }
       if(this.glitchCount>10){
         this.glitchCount+=Math.random()*40
          setTimeout(this.glitch,Math.random()*100+100);
          
          return
         
       }
        
       
        for(var g in this.glitches){
          if(Math.random()*10>7){
            this.glitches[g].height=Math.random()*20+5;
            for(var gc in this.glitches[g].child){
                this.glitches[g].child[gc]=Math.floor(Math.random()*160+20);
            }
             if(Math.random()*10>5){
               this.glitches[g].height=0;
             }
          }
          this.glitches[g].pad=Math.floor(Math.random()*5+5)
          this.glitches[g].width=Math.floor(Math.random()*160+20) 
        }
        if(Math.random()*10>5){
         // this.glitchTop=Math.random()*400+100;
        }
        setTimeout(this.glitch,100);
     }
     
   }
 }
</script>

<style scoped>
  .glitchHolder{
    position: absolute;
    top: 0px;
    height: 100%;
    width: 100%;
    min-height: 100px;
    overflow: hidden;
    pointer-events: none;
  }
  #glitchOverlay{
  position:absolute;
  left:-100px;
  top:0px;
}
.glitchOver{
  
  z-index:3;
  position:relative;
  min-height:30px;
  pointer-events:none;
  opacity:0.3;
  width:400px;
  
}
.glitchChild{
  width:40px;
  display:inline-block;
  background-color:#00f;
}

</style>



// WEBPACK FOOTER //
// src/components/Opportunities.vue